<style lang="scss">
.serviceallot {
	.vview-formitem {
		min-height: 32px;
	}
}
.allotdetail-query {
	.vview-formitem {
		margin-bottom: 9px;
	}
	.vview-formitem-content {
		font-weight: 800;
	}
}
</style>

<template>
	<div :class="wrapClasses">
		<vAlert v-if="transferType==0">适用于以下调拨场景：服务仓-服务仓；服务仓-自有仓；自有仓-服务仓；自有仓-自有仓。如有问题可联系商舟客服咨询。</vAlert>
		<vAlert v-if="transferType==1">适用于以下调拨场景：服务仓或自有仓调出至wayfair等其它平台，如有问题可联系商舟客服咨询。</vAlert>
		<vAlert v-if="transferType==2">适用于以下调拨场景：从自有仓或服务仓申请产品调拨出库，将产品退回指定地点。如有问题可联系商舟客服咨询。</vAlert>
		<vAlert v-if="transferType==3">适用于以下调拨场景：从自有仓或服务仓调拨至亚马逊仓。如有问题可联系商舟客服咨询</vAlert>
		<compWrapper title="基本信息" theme="primary">
			<vForm :label-width="130" ref="form" class="margin-15 clearfix" :rules="getRules">
				<vCol span="12" v-if="formData.transferId">
					<vFormItem
						label="调拨计划单号"
					>{{formData.transferOutboundPlanNo}} ({{formData.transferOutboundPlanStatus | filterstatus}})</vFormItem>
				</vCol>
				<vCol span="12">
					<vFormItem label="项目" :prop="type==='edit'?'':'lineId'">
						<span v-if="formData.transferId">{{ this.findRenderLabel(this.getNewProductList, formData.lineId) }}</span>
						<vSelect v-else v-model="formData.lineId" :strict="false" filterable clearable>
							<vOption v-for="item in getNewProductList" :value="item.value" :key="item.value">{{item.label}}</vOption>
						</vSelect>
					</vFormItem>
				</vCol>
				<vCol span="12">
					<vFormItem v-if="query" label="内部识别号">{{formData.internalDiscernNo}}</vFormItem>
					<vFormItem v-else label="内部识别号" tip="<span class='color-error'>可填写便于内部识别和追溯的号</span>">
						<vInput v-model="formData.internalDiscernNo"/>
					</vFormItem>
				</vCol>
				<vCol span="12" v-if="transferType!=7">
					<vFormItem label="调出仓库" prop="orgWarehouseId">
						<span v-if="query">{{ this.findRenderLabel(this.getNewWarehouseIdList, formData.orgWarehouseId) }}</span>
						<vSelect v-else v-model="formData.orgWarehouseId" :strict="false" filterable clearable>
							<vOption
								v-for="item in filterWarehouses(formData.inOrgWarehouseId)"
								:value="item.value"
								:key="item.value"
							>{{item.label}}</vOption>
						</vSelect>
					</vFormItem>
				</vCol>
				<vCol span="12" v-if="transferType==7">
					<vFormItem label="调出仓库" prop="orgWarehouseId">
						<span v-if="query">{{getWarehouseName(formData.orgWarehouseId,'outware')}}</span>
						<vSelect v-else v-model="formData.orgWarehouseId" :strict="false" filterable clearable @on-change="getChannel(formData.orgWarehouseId,'outware')">
							<vOption
								v-for="item in getFilterDisabledAllWarehouse"
								:value="item.value"
								:key="item.value"
							>{{item.label}}</vOption>
						</vSelect>
					</vFormItem>
				</vCol>
				<vCol span="12" v-if="transferType==7 && showOnaccount">
					<vFormItem label="ONSITE仓调出渠道" prop="onsiteChannel">
						<span v-if="query">{{formData.onsiteChannel}}</span>
						<vSelect v-else v-model="formData.onsiteChannel" :strict="false" filterable clearable >
							<vOption
								v-for="item in channelList1"
								:value="item.accountFlag"
								:key="item.accountId"
							>{{item.accountFlag}}</vOption>
						</vSelect>
					</vFormItem>
				</vCol>
				<vCol span="12" v-if="transferType==1">
					<vFormItem label="调入渠道" prop="inOrgWarehouseId">
						<span v-if="query">{{formData.sourceChannel}}</span>
						<vSelect
							v-else
							v-model="formData.inOrgWarehouseId"
							:strict="false"
							filterable
							clearable
							@on-change="getAllotAddress"
						>
							<vOption
								v-for="item in filterWarehouses(formData.orgWarehouseId,true)"
								:value="item.value"
								:key="item.value"
							>{{item.attach.item.code}}</vOption>
						</vSelect>
					</vFormItem>
				</vCol>
				<vCol span="12" v-if="transferType!=2&&transferType!=7">
					<vFormItem label="调入仓库" prop="inOrgWarehouseId">
						<span v-if="query">{{ this.findRenderLabel(this.getNewWarehouseIdList, formData.inOrgWarehouseId) }}</span>
						<vSelect
							v-else
							v-model="formData.inOrgWarehouseId"
							:strict="false"
							filterable
							clearable
							@on-change="getAllotAddress(formData.inOrgWarehouseId)"
						>
							<vOption
								v-for="item in filterWarehouses(formData.orgWarehouseId,true)"
								:value="item.value"
								:key="item.value"
							>{{item.label}}</vOption>
						</vSelect>
					</vFormItem>
				</vCol>
				<vCol span="12" v-if="transferType==7">
					<vFormItem label="调入仓库" prop="inOrgWarehouseId">
						<span v-if="query">{{getWarehouseName(formData.inOrgWarehouseId,'inware')}}</span>
						<vSelect v-else v-model="formData.inOrgWarehouseId" :strict="false" filterable clearable @on-change="getChannel(formData.inOrgWarehouseId,'inware')" >
							<vOption
								v-for="item in getFilterDisabledAllWarehouse"
								:value="item.value"
								:key="item.value"
							>{{item.label}}</vOption>
						</vSelect>
					</vFormItem>
				</vCol>
				<vCol span="12" v-if="(transferType==0||transferType==1||transferType==3)&&showInTime==true">
					<vFormItem label="期望入库日期" prop="estimateInboundAt">
						<span v-if="query">{{formData.estimateInboundAt}}</span>
                        <vDatepicker v-else v-model="formData.estimateInboundAt" format='yyyy-mm-dd'></vDatepicker>
					</vFormItem>
				</vCol>
				<vCol span="12" v-if="(transferType==0||transferType==1||transferType==3)&&showInTime==false">
					<vFormItem label="期望入库日期">
						<span v-if="query">{{formData.estimateInboundAt}}</span>
                        <vDatepicker v-else v-model="formData.estimateInboundAt" format='yyyy-mm-dd'></vDatepicker>
					</vFormItem>
				</vCol>
				<vCol span="12" v-if="transferType==7 && showInaccount">
					<vFormItem label="ONSITE仓调入渠道" prop="inOnsiteChannel">
						<span v-if="query">{{formData.inOnsiteChannel}}</span>
						<vSelect v-else v-model="formData.inOnsiteChannel" :strict="false" filterable clearable >
							<vOption
								v-for="item in channelList2"
								:value="item.accountFlag"
								:key="item.accountId"
							>{{item.accountFlag}}</vOption>
						</vSelect>
					</vFormItem>
				</vCol>
				<vCol span="12" v-if="transferType==7">
					<vFormItem label="transfer ID" prop="shipmentId">
						<span v-if="query">{{formData.shipmentId}}</span>
						<vInput v-else v-model="formData.shipmentId"/>
					</vFormItem>
				</vCol>
				<vCol span="12" v-if="transferType==1||transferType==3">
					<vFormItem label="调入地址code" prop="receiveStore">
						<span v-if="query">{{formData.receiveStore}}</span>
						<vSelect
							v-else
							:value="formData.receiveStore"
							@input="getAllotAddressByCode"
							filterable
							clearable
						>
							<vOption v-for="item in codeList" :value="item" :key="item">{{item}}</vOption>
						</vSelect>
					</vFormItem>
				</vCol>
				<vCol span="12" v-if="transferType==1">
					<vFormItem label="调拨类型" prop="isOnsite">
						<span v-if="query||type==='edit'">{{formData.isOnsite==0?'普通':'onsite'}}</span>
						<vSelect v-else v-model="formData.isOnsite" :strict="false" filterable clearable>
							<vOption value="0">普通</vOption>
							<vOption value="1">onsite</vOption>
						</vSelect>
					</vFormItem>
				</vCol>
				<vCol span="12">
					<vFormItem label="库存类型" prop="inventoryType">
						<span v-if="query">{{formData.inventoryType==1?'不可售库存':'可售库存'}}</span>
						<!-- <vSelect v-else v-model="formData.inventoryType" :strict="false" filterable clearable>
							<vOption value="0">可售库存</vOption>
							<vOption value="1">不可售库存</vOption>
						</vSelect>-->
						<template v-else>
							<vRadio
								trueValue="0"
								:strict="false"
								v-model="formData.inventoryType"
								class="margin-right-10"
							>可售库存</vRadio>
							<vRadio trueValue="1" :strict="false" v-model="formData.inventoryType">不可售库存</vRadio>
						</template>
					</vFormItem>
				</vCol>
				<vCol span="12">
					<vFormItem label="是否更换产品标" prop="isLabel">
						<span v-if="query">{{formData.isLabel==1?'是':'否'}}</span>
						<template v-else>
							<vRadio trueValue="1" :strict="false" v-model="formData.isLabel" class="margin-right-10">是</vRadio>
							<vRadio trueValue="0" :strict="false" v-model="formData.isLabel">否</vRadio>
						</template>
					</vFormItem>
				</vCol>
				<vCol span="12">
					<vFormItem label="运输方式" prop="transportationType">
						<span v-if="query">{{formData.transportationType==2?'仓库安排':'客户安排'}}</span>
						<template v-else>
							<vRadio
								trueValue="1"
								:strict="false"
								v-model="formData.transportationType"
								class="margin-right-10"
							>客户安排</vRadio>
							<vRadio trueValue="2" :strict="false" v-model="formData.transportationType">仓库安排</vRadio>
						</template>
					</vFormItem>
				</vCol>
				<vCol span="12" v-if="transferType==3">
					<vFormItem label="Shipment ID" prop="shipmentId">
						<span v-if="query||type==='edit'">{{formData.shipmentId}}</span>
						<vInput v-else v-model="formData.shipmentId"/>
					</vFormItem>
				</vCol>
				<vCol span="12" v-if="transferType==3">
					<vFormItem label="Reference ID" prop="removeOrderId">
						<span v-if="query||type==='edit'">{{formData.removeOrderId}}</span>
						<vInput v-else v-model="formData.removeOrderId"/>
					</vFormItem>
				</vCol>
				<template v-if="transferType!=2">
					<vCol span="12">
						<vFormItem label="目的地址">{{formData|handleAddress}}</vFormItem>
					</vCol>
					<vCol span="12">
						<vFormItem label="联系人">
							<span>{{formData.shipToContact}}</span>
						</vFormItem>
					</vCol>
					<vCol span="12">
						<vFormItem label="电话">
							<span>{{formData.shipToTelephone}}</span>
						</vFormItem>
					</vCol>
					<vCol span="12">
						<vFormItem label="移动电话">
							<span>{{formData.shipToMobile}}</span>
						</vFormItem>
					</vCol>
				</template>
				<template v-else>
					<vCol span="12">
						<vFormItem label="目的国家" prop="shipToCountry">
							<span v-if="query">{{formData.shipToCountry}}</span>
							<vInput v-else v-model="formData.shipToCountry" filterable clearable>
								<vOption value="US">US</vOption>
								<vOption value="ES">ES</vOption>
								<vOption value="DE">DE</vOption>
								<vOption value="JP">JP</vOption>
							</vInput>
						</vFormItem>
					</vCol>
					<vCol span="12">
						<vFormItem label="州" prop="shipToState">
							<span v-if="query">{{formData.shipToState}}</span>
							<template v-else>
								<vInput
									v-if="formData.shipToCountry==='US'"
									v-model="formData.shipToState"
									filterable
									clearable
								>
									<vOption v-for="item in getStateList" :value="item" :key="item">{{item}}</vOption>
								</vInput>
								<vInput v-else v-model="formData.shipToState" clearable></vInput>
							</template>
						</vFormItem>
					</vCol>
					<vCol span="12">
						<vFormItem label="城市" prop="shipToCity">
							<span v-if="query">{{formData.shipToCity}}</span>
							<vInput v-else v-model="formData.shipToCity"></vInput>
						</vFormItem>
					</vCol>
					<vCol span="12">
						<vFormItem label="邮编" prop="shipToPostal">
							<span v-if="query">{{formData.shipToPostal}}</span>
							<vInput v-else v-model="formData.shipToPostal"></vInput>
						</vFormItem>
					</vCol>
					<vCol span="12">
						<vFormItem label="联系人" prop="shipToContact">
							<span v-if="query">{{formData.shipToContact}}</span>
							<vInput v-else v-model="formData.shipToContact"></vInput>
						</vFormItem>
					</vCol>
					<vCol span="12">
						<vFormItem label="地址1" prop="shipToAddress1">
							<span v-if="query">{{formData.shipToAddress1}}</span>
							<vInput v-else v-model="formData.shipToAddress1"></vInput>
						</vFormItem>
					</vCol>
					<vCol span="12">
						<vFormItem label="电话" prop="shipToTelephone">
							<span v-if="query">{{formData.shipToTelephone}}</span>
							<vInput v-else v-model="formData.shipToTelephone"></vInput>
						</vFormItem>
					</vCol>
					<vCol span="12">
						<vFormItem label="地址2">
							<span v-if="query">{{formData.shipToAddress2}}</span>
							<vInput v-else v-model="formData.shipToAddress2"></vInput>
						</vFormItem>
					</vCol>
					<vCol span="12">
						<vFormItem label="移动电话">
							<span v-if="query">{{formData.shipToMobile}}</span>
							<vInput v-else v-model="formData.shipToMobile"></vInput>
						</vFormItem>
					</vCol>
				</template>
				<vCol span="12">
					<vFormItem label="附件">
						<template v-if="query">
							<a
								v-for="(item,index) in formData.transferPlanAnnexList"
								:key="index"
								download
								:href="item.fileUrl"
								:class="padding-10"
							>{{item.fileName}}</a>
						</template>
						<vInput
							v-else
							v-model="formData.transferPlanAnnexList"
							@on-remove="deleteFile"
							readonly
							multiple
							multipleKey="fileName"
						>
							<vButton slot="suffix" ghost theme="primary" @click="handleUpload">上传</vButton>
						</vInput>
					</vFormItem>
				</vCol>
				<vCol span="24">
					<vFormItem label="备注">
						<span v-if="query">{{formData.remark}}</span>
						<vInput v-else type="textarea" v-model="formData.remark"></vInput>
					</vFormItem>
				</vCol>
			</vForm>
		</compWrapper>
		<compWrapper title="调拨产品行" theme="success">
			<compAllotlist ref="allotlist" v-bind="handleAllotProps"></compAllotlist>
			<template v-if="!query" slot="footer">
				<vButton class="margin-right-20" theme="primary" @click="submitSave">保存</vButton>
				<vButton class="margin-right-20" theme="error" @click="submitSave(true)">提交</vButton>
				<vButton class="margin-right-20" @click="handleGoback">返回</vButton>
			</template>
		</compWrapper>
		<compWrapper title="操作历史" theme="gray" v-if="query">
			<compLog :data="logList"></compLog>
		</compWrapper>
		<compDelayloading
			:loading="loading"
			:delay="loading!==true"
			@on-cancel="cancelloading"
			@on-back="handleGoback"
		></compDelayloading>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { HttpSaveAllot, HttpErpSkuList, HttpAllot, HttpUpdateAllotStatus, HttpDelAllotFile, HttpFindByOrgIdAndOrgWarehouseId } from '@/service/allotment/allots'
import { HttpAllotAddress } from '@/service/boss/dictionary'
import { HttpWareHouseCodeList } from '@/service/boss/shipment'
import compAllotlist from './allotslist'
import compLog from './log'
import compUpload from '@components/templates/upload'
export default {
	props:['activeids','transType','querytype'],
	components: {
		compWrapper: () => import("@components/templates/wrapper"),
		compDelayloading: () => import("@components/templates/delayloading"),
		// compFormQuery: () => import("@components/templates/formquery"),
		// compFormEdit: () => import("@components/templates/formedit"),
		compAllotlist,
		compLog
	},
	data() {
		return {
			loading: false,
			visible: false,
			type: this.$route.params.type,
			transferType: this.$route.query.transferType,
			id: this.$route.query.id,
			showInTime:true,
			codeList: [],
			logList: [],
			formData: {
				inventoryType: 0,
				isLabel: 0,
				transferPlanAnnexList: [],
				isOnsite: 0,
				transportationType: 2,
				shipToCountry: ""
			},
			channelList1:[],
			channelList2:[],
			showOnaccount:false,
			showInaccount:false,
			mountedflag:false,
			
		}
	},
	created() {
		if(this.activeids){
			this.id = this.activeids
			this.type = this.querytype,
			this.transferType = this.transType
		}
		this.query = this.type === 'query';
		// if (this.transferType == 1) this.formData.isOnsite = 2;
		if (this.transferType == 7 || this.transferType == 1) this.formData.isOnsite = 1;
		if (this.transferType == 2) this.formData.shipToCountry = "US"
		this.getDetail();
	},
	filters: {
		handleAddress(formData) {
			const data = [];
			['shipToAddress2', 'shipToAddress1', 'shipToCity', 'shipToState', 'shipToCountry'].forEach((key) => {
				if (formData[key]) data.push(formData[key])
			});
			return data.join(',')
		},
		filterstatus(value) {
			switch (value) {
				case 0: return '草稿'; break;
				case 3: return '已驳回'; break;
				case 5: return '待审核'; break;
				case 10: return '待出库'; break;
				case 15: return '出库中'; break;
				case 20: return '已出库'; break;
				case 25: return '入库中'; break;
				case 70: return '已完成'; break;
				case 90: return '已关闭'; break;
			}
		}
	},
	watch: {
		"$route": function (to, from) {
			this.getDetail()
		}
	},
	computed: {
		...mapState('boss', ['products', 'warehouseList']),
		...mapGetters('common', ['getStateList']),
		...mapGetters('dictionary',['getFilterDisabledAllWarehouse']),
		...mapGetters('diction',['getNewWarehouseIdList','getNewProductList']),
		hasOnsite() {
			return this.transferType == 0 && this.$route.name.indexOf('onsiteAllot') > -1
		},
		isOnsiteWarehouse(){
			const warehouseId=this.formData.orgWarehouseId
			return this.getNewWarehouseIdList.some(item=>{
				return item.value==warehouseId&&item.attach.item.warehouseType==4
			})
		},
		wrapClasses() {
			return {
				'serviceallot': true,
				'allotdetail-query': this.query
			}
		},
		getRules() {
			return this.type === 'query' ? [] : {
				['*']: {
					required: true,
					message: "该信息不能为空,请填写"
				}
			}
		},
		handleAllotProps() {
			return {
				type: this.type,
				transferType: this.transferType,
				inventoryType: this.formData.inventoryType,
				orgWarehouseId: this.formData.orgWarehouseId,
				transferOutboundPlanNo: this.formData.transferOutboundPlanNo,
				transferId: this.id,
				lineId: this.formData.lineId,
				isOnsiteWarehouse:this.isOnsiteWarehouse,
			}
		},
	},
	methods: {
		getWarehouseName(val,type){
			let jsonone,index=1;
			if(this.mountedflag){
				if(type=='outware'){
					jsonone = (this.getFilterDisabledAllWarehouse.filter(item=>{ return item.value == val })[0] || {})
				}else{
					jsonone = (this.getFilterDisabledAllWarehouse.filter(item=>{ return item.value == val })[0] || {})
				}
				return jsonone.label
			}
		},
		handleUpload() {
			const data = {
				attrs: {
					data: { contextId: global.SYSID },
					action: process.env.VUE_APP_APIURL_FBB + "/api/v2/Transfer/uploadAnnex",
					name: "excelFile",
				},
				on: {
					'on-success': (res) => {
						this.$VModal.destroy();
						if (!this.formData.transferPlanAnnexList) this.formData.transferPlanAnnexList = [];
						this.formData.transferPlanAnnexList.push(res.data);
					},
					'on-cancel': () => {
						this.$VModal.destroy();
					}
				}
			}
			this.$VModal.default({
				title: "导入数据",
				width: 460,
				showFooter: false,
				render: (h, props) => {
					return h(compUpload, data)
				}
			})
		},
		filterWarehouses(id, isIn) {
			const transferType = this.transferType;
			return isIn !== true ? this.getNewWarehouseIdList.filter(item => {
				// console.log(item)
				const bool = item.attach.item.warehouseType == 1 || item.attach.item.warehouseType == 3;
				if (transferType == 7 ) {
					return item.value != id && (bool || item.attach.item.warehouseType == 4);
				}
				if(transferType == 2){
					return item.value != id && (bool || item.attach.item.warehouseType == 4 || item.attach.item.warehouseType == 5);
				}
				return item.value != id && (bool || item.attach.item.warehouseType == 5);
			}) : this.getNewWarehouseIdList.filter(function (item) {
				if (transferType == 0) {
					return item.value != id && (item.attach.item.warehouseType == 1 || item.attach.item.warehouseType == 3 || item.attach.item.warehouseType == 5)
				}
				if (transferType == 7) {
					return item.value != id && (item.attach.item.warehouseType == 1 || item.attach.item.warehouseType == 4)
				}
				if (transferType == 1) {
					return item.value != id && (item.attach.item.warehouseType == 2 || item.attach.item.warehouseType == 5)//&& /wayfair/ig.test(item.code || ""
				}
				if (transferType == 3) {
					return item.value != id && (item.attach.item.warehouseType == 2 || item.attach.item.warehouseType == 5)
				}
				return true
			})
		},
		// 根据仓库获取对应的渠道列表
		getChannel(wareId,type){
			// 根据仓库id请求对应的type
			if(type == 'outware'){
				let attatype = this.getFilterDisabledAllWarehouse.filter(item=>{ return item.value == wareId })[0] || {}
				if(attatype.attach.warehouseType!=4){
					this.showOnaccount = false
					return;
				} else this.showOnaccount = true
			}else {
				let attatype = this.getFilterDisabledAllWarehouse.filter(item=>{ return item.value == wareId })[0] || {}
				if(attatype.attach.warehouseType!=4){
					this.showInaccount = false
					return;
				} else {
					this.showInaccount = true
					this.getAllotAddress(wareId)
				}
			}
			this.gethtpchannellist(wareId,type)
			
		},
		gethtpchannellist(wareId,type){
			HttpFindByOrgIdAndOrgWarehouseId({
				orgId:global.SYSID,
				orgWarehouseId:wareId
			}).then(res=>{
				if(type === 'outware'){
					this.channelList1 = []
					this.channelList1 = res.data;
				} else {
					this.channelList2 = []
					this.channelList2 = res.data; 
				}
			},err=>{
				this.$$VMessage.error(err.message)
			})
		},
		getWareHouseCode(val) {
            // console.log(val,'22222222333333')
            if(val){
                let jsonone;
                if(this.transferType == 7){
                    jsonone = (this.getFilterDisabledAllWarehouse.find(item => {
                        return item.value == val
                    }) || {}).attach.code
                }else{
                    jsonone = (this.getNewWarehouseIdList.find(item => {
                        return item.value == val
                    }) || {}).attach.item.code
                }
                return jsonone
            }
		},
		handleRequest() {
			return {
				transferType: this.transferType,
				transferPlanBaseInfo: { ... this.formData, orgWarehouseCode: this.getWareHouseCode(this.formData.orgWarehouseId), inOrgWarehouseCode: this.getWareHouseCode(this.formData.inOrgWarehouseId) },
				transferPlanProductList: this.$refs.allotlist.dataList
			}
		},
		handleResponse(data) {
			this.$refs.allotlist.dataList = data.transferPlanProductList || [];
			this.logList = data.orderLogList;
			this.formData = data.transferPlanBaseInfo;
			if (this.transferType == 3) {
				this.getWHCodeList(this.formData.inOrgWarehouseId)
			}
			if (this.transferType == 1) {
				const code = this.formData.sourceChannel;
				this.formData.inOrgWarehouseId = (this.getNewWarehouseIdList.find(item => {
					return item.attach.item.code == code
				}) || {}).attach.item.id;
				// console.log(this.formData.inOrgWarehouseId)
				this.getWHCodeList(this.formData.inOrgWarehouseId)
			}
			if (this.transferType == 0||this.transferType == 1||this.transferType == 3) {
				let attatype = this.getNewWarehouseIdList.filter(item=>{ return item.value == this.formData.inOrgWarehouseId })[0] || {}
				if(attatype.attach.item.warehouseType==2){
					this.showInTime = false;
				} else {
					this.showInTime = true;
				}
			}
			this.formData = Object.assign({}, this.formData);
			// 判断页面渠道的展示
			if(this.transferType == 7){
				let showOnaccount1 = (this.getFilterDisabledAllWarehouse.filter(item=>{return item.value == this.formData.orgWarehouseId})[0] || {})
				// console.log(showOnaccount1)
				if(showOnaccount1.attach.warehouseType==4){
					this.getChannel(this.formData.orgWarehouseId,'outware')
					this.showchannel1 = true
				} else this.showchannel1 = false		
				let showInaccount2 = (this.getFilterDisabledAllWarehouse.filter(item=>{return item.value == this.formData.inOrgWarehouseId})[0] || {})
				// console.log(showOnaccount1)
				if(showInaccount2.attach.warehouseType==4){
					this.getChannel(this.formData.inOrgWarehouseId,'inware')
					this.showchannel2 = true
				} else this.showchannel2 = false	
			}	


		},
		cancelloading() {
			this.loading = false;
			this.$router.push({
				name: this.$route.name,
				params: { type: "edit" },
				query: { id: this.formData.transferId, transferType: this.transferType },
			});
		},
		handleGoback() {
			clearTimeout(this.timeout);
			this.$router.push({ name: this.$route.name.slice(0, -6) });
		},
		//仓库code list
		async getWHCodeList(val) {
			if (this.query) return;
			HttpWareHouseCodeList({
				warehouseId: val
			}).then(res => {
				// this.codeList = this.transferType == 1 ? (res.data || []).filter(function (item) { return /wayfair/ig.test(item) }) : res.data;
				this.codeList = res.data;
			}, err => {
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			});
		},
		getAllotAddressByCode(val) {
			this.formData.receiveStore = val;
			if (!val) return;
			this.getAddress({
				warehouseId: this.formData.inOrgWarehouseId,
				addressCode: val
			})
		},

		async getAllotAddress(val, type) {
			console.log(val);
			if (!val) return;
			//当仓库是亚马逊仓时，需要传递仓库code
			if (this.transferType == 1 || this.transferType == 3) {
				this.codeList = [];
				this.formData.receiveStore = '';
				//判断期望入库日期
				let attatype = this.getNewWarehouseIdList.filter(item=>{ return item.value == val })[0] || {}
				if(attatype.attach.item.warehouseType==2){
					this.showInTime = false;
				} else {
					this.showInTime = true;
				}
				return this.getWHCodeList(val);
			}
			this.getAddress({ warehouseId: val });
		},
		async getAddress(data) {
			HttpAllotAddress(data).then(res => {
				const { address, address2, city, state, country, postal, phone, mobilePhone, linkman, code } = res.data;
				this.formData = {
					...this.formData,
					receiveStore: code,
					shipToAddress1: address,
					shipToAddress2: address2,
					shipToCity: city,
					shipToState: state,
					shipToCountry: country,
					shipToPostal: postal,
					shipToTelephone: phone,
					shipToMobile: mobilePhone,
					shipToContact: linkman
				}
			});
		},
		async getDetail() {
			if (this.type === 'add') return;
			this.loading = true;
			HttpAllot({
				transferId: this.id,
				node: this.transferType,
			}).then(res => {
				this.handleResponse(res.data);
				this.mountedflag = true;
				this.loading = false;

			}, err => {
				this.loading = false;
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			})
		},
		async deleteFile({ annexId }) {
			HttpDelAllotFile({ annexId }).catch(err => {
				this.loading = false;
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			});
		},
		submitStatus(id, transferNo) {
			this.$VModal.info({
				title: "提交信息",
				content: "交后将由商舟仓储人员审核，预计3-7个工作日可查看审核结果。注意：审核通过后不可更改单据信息，如有问题可联系商舟客服。确认提交？",
				async: true,
			}, {
					'on-after-close': () => {
						this.$VModal.destroy();
					},
					'on-confirm': (name) => {
						HttpUpdateAllotStatus({
							id: id || this.transferId,
							status: 210,
						}).then(res => {
							this.$VMessage.success({
								content: `单号为:${transferNo}`,
								duration: 10,
							});
							this.handleGoback();
							this.$VModal.destroy();
						}, err => {
							this.$VModal.get(name).loading = false;
							this.$VMessage.error({
                                content: err.message,
                                duration: 30,
                                closable: true
                            });
						})
					}
				})
		},
		async submitSave(next) {
			const data = await this.$refs['form'].validate();
			if (!data) return this.$VMessage.warning('请填写必填项');
			this.loading = true;
			
			return HttpSaveAllot(this.handleRequest()).then(res => {
				const { transferId, transferNo } = res.data;
				this.loading = false;
				this.formData.transferId = transferId;
				this.formData.transferOutboundPlanNo = transferNo
				if (next === true) return this.submitStatus(transferId, transferNo);
				// this.$VMessage.success({
				// 	content: `单号为:${transferNo}`,
				// 	duration: 10,
				// });
				this.loading = 1;
			}, err => {
				this.loading = false;
				this.$VMessage.error({
                    content: err.message,
                    duration: 30,
                    closable: true
                });
			});
		}
	},

}
</script>

